export default () => ({
    eventosactivos: [], localidades: [], eventosactivosexhibicion: []
})